module.exports = __webpack_public_path__ + "img/woman.6d1b8cf4.png";